import { Link } from "react-router-dom";
import type { Manga } from "@/mocks/manga";

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
      data-product-shop
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium text-background-50 ${
            manga.status === "已完结" ? "bg-secondary-600" : "bg-primary-500"
          }`}
        >
          {manga.status}
        </span>
        <span className="absolute right-3 top-3 flex h-7 items-center gap-1 whitespace-nowrap rounded-full bg-black/45 px-2.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400" aria-hidden="true"></i>
          {manga.rating}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
          {manga.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600">
          {manga.author} · {manga.genre}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {manga.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs text-foreground-500">
          更新至 <span className="text-foreground-800">{manga.latest}</span>
        </p>
      </div>
    </Link>
  );
}